var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 504,
    viewBox: "0 0 1600 504",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_407_94919",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1600,
    height: 504
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 504,
    fill: "url(#paint0_linear_407_94919)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_407_94919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M680.552 55.6789C663.871 37.1125 638.026 40.4358 618.086 51.3324C607.874 56.9121 597.186 64.4127 592.509 75.5006C588.832 84.218 589.339 95.2129 595.496 102.752C601.857 110.539 613.353 112.488 622.006 107.512C631.026 102.326 634.713 90.56 630.424 81.1065C622.173 62.9272 596.924 62.2992 580.601 67.1442C558.475 73.7097 541.016 91.9991 535.297 114.203C533.7 120.397 543.586 121.915 545.175 115.745C548.685 102.117 557.838 90.583 569.632 83.061C580.99 75.8157 596.746 71.5295 609.913 76.2329C615.439 78.2075 621.545 82.0822 622.233 88.4552C623.15 96.9809 613.629 103.282 606.132 98.9714C599.586 95.2089 599.016 85.8861 601.627 79.6067C605.013 71.4672 612.836 65.9673 620.153 61.5997C635.443 52.4701 658.567 46.0315 672.422 61.4552C676.68 66.1954 684.845 60.462 680.554 55.6835L680.552 55.6789Z",
    fill: "#BBBCEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7265 278.575C27.9139 277.919 12.0265 262.988 11.2636 243.932C11.1431 240.895 9.16764 238.176 5.92918 238.006C3.10246 237.858 -0.118369 240.284 0.00334704 243.341C0.471606 255.115 4.84528 266.598 13.0843 275.155C21.7244 284.128 33.6999 289.401 46.135 289.835C53.3769 290.089 54.0027 278.827 46.7231 278.573L46.7265 278.575Z",
    fill: "#B7BEEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.059 182.514C776.483 179.466 762.627 162.634 764.298 143.636C764.565 140.608 762.952 137.66 759.762 137.079C756.977 136.571 753.474 138.567 753.205 141.615C752.169 153.353 755.045 165.299 762.127 174.836C769.553 184.836 780.759 191.592 793.038 193.607C800.188 194.781 802.244 183.691 795.056 182.511L795.059 182.514Z",
    fill: "#BDBAE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1503.73 308.536C1485.44 304.079 1472.91 286.237 1476.03 267.422C1476.53 264.424 1475.15 261.361 1472.01 260.538C1469.27 259.82 1465.63 261.542 1465.12 264.56C1463.2 276.185 1465.15 288.316 1471.48 298.365C1478.12 308.904 1488.78 316.496 1500.87 319.443C1507.91 321.16 1510.81 310.259 1503.73 308.534L1503.73 308.536Z",
    fill: "#B6BFEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.79 274.068C1142.98 267.123 1143.92 259.894 1146.61 253.411C1146.09 254.204 1145.56 254.999 1145.04 255.788C1145.11 255.721 1145.18 255.652 1145.25 255.585L1142.39 256.171C1145.92 256.194 1149.78 257.589 1153.23 258.333C1157.19 259.187 1161.15 260.04 1165.1 260.893C1168.74 261.678 1171.97 259.786 1172.46 255.961C1172.96 252.115 1173.71 248.348 1174.77 244.613C1175.28 242.823 1175.85 241.053 1176.48 239.299C1176.88 238.183 1177.74 235.11 1178.14 234.751L1175.48 236.08C1175.77 236.053 1176.06 236.031 1176.35 236.003C1175.41 235.945 1174.45 235.888 1173.51 235.833C1182.03 238.754 1190.28 243.053 1198.54 246.648C1201.3 247.847 1204.72 245.773 1205.62 243.11C1206.66 240.04 1204.88 237.302 1202.11 236.097C1196.82 233.793 1191.52 231.488 1186.22 229.18C1181.86 227.281 1175.25 222.709 1170.7 226.516C1167.35 229.321 1165.96 235.359 1164.72 239.355C1163.11 244.55 1162.02 249.896 1161.32 255.277C1163.77 253.633 1166.23 251.989 1168.68 250.345C1163.4 249.209 1158.12 248.071 1152.85 246.935C1148.58 246.017 1142.95 243.668 1138.92 246.368C1135.16 248.885 1134.3 254.891 1133.42 258.984C1132.39 263.737 1131.78 268.521 1131.64 273.382C1131.44 280.525 1142.59 281.226 1142.79 274.07L1142.79 274.068Z",
    fill: "#B6BFEC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 875,
    cy: 74,
    r: 7,
    fill: "#BABCEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1471,
    cy: 45,
    r: 7,
    fill: "#BABCEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 48,
    r: 7,
    fill: "#BABCEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1550,
    cy: 497,
    r: 7,
    fill: "#BABCEB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_407_94919",
    x1: 800,
    y1: 0,
    x2: 800,
    y2: 504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCD8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500101,
    stopColor: "#D3DFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4EBFB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.f208e3f3466288a1c4adf1c929d3d1ba.svg";
export { ForwardRef as ReactComponent };